<button class="activity-block-header" type="button" (click)="onHeaderClick()" [attr.aria-expanded]="!$isCollapsed()">
  <div class="activity-block-label">
    @if ($isLive()) {
      <!-- Rotating playful word; rolls up on change and pulses between greys while live -->
      <span class="activity-block-working">
        @for (word of [$workingWord()]; track word) {
          <span class="activity-block-word">{{ word }}…</span>
        }
      </span>
    } @else {
      <span class="activity-block-text">{{ $headerText() }}</span>
    }
  </div>
  <i class="fas fa-chevron-right activity-block-chev" [class.open]="!$isCollapsed()"></i>
</button>
<div class="activity-block-body" [class.open]="!$isCollapsed()">
  <div class="activity-block-body-inner">
    @for (entry of $enrichedEntries(); track entry.key; let last = $last) {
      @if (entry.type === 'reasoning') {
        @let content = renderedTextContent(entry.partIndex, entry.part);
        <!-- {} -->
        <agent-step-item [type]="'thinking'" [status]="content ? 'complete' : 'current'" [isLast]="last">
          <div class="step-text-content">
            @if (content) {
              <markdown [data]="content" />
            }
          </div>
        </agent-step-item>
      } @else if (entry.type === 'tool') {
        <agent-step-item [type]="entry.stepType" [status]="entry.stepStatus" [isLast]="last">
          @if (entry.expandable) {
            <button class="step-tool-label" type="button" (click)="onToolExpandClick(entry.toolCallId, $event)">
              <span>{{ entry.label }}</span>
              <i class="fas fa-chevron-right step-tool-chev" [class.open]="$expandedTools().has(entry.toolCallId)"></i>
            </button>
            <div class="step-tool-output" [class.open]="$expandedTools().has(entry.toolCallId)">
              <div class="step-tool-output-inner">
                <agent-tool-result-summary [summary]="entry.outputSummary" />
              </div>
            </div>
          } @else {
            <span class="step-tool-label step-tool-label--static">{{ entry.label }}</span>
          }
          @if (entry.meta) {
            <span class="step-meta">{{ entry.meta }}</span>
          } @else if (entry.stepStatus === 'error') {
            <span class="step-tool-error">{{ entry.errorText }}</span>
          } @else if (entry.stepStatus === 'denied') {
            <span class="step-tool-denied">{{ entry.expired ? 'This request expired before it was answered' : 'You declined this action' }}</span>
          }
        </agent-step-item>
      } @else if (entry.type === 'text') {
        @let content = renderedTextContent(entry.partIndex, entry.part);
        <!-- {} -->
        @if (content) {
          <agent-step-item [type]="'text'" [status]="'complete'" [isLast]="last">
            <div class="step-text-content">
              <markdown [data]="content" />
            </div>
          </agent-step-item>
        }
      }
    }
  </div>
</div>
